exports.connect = {
	url: "https://api.lebothdorouet.camp/"
}
